import { render, staticRenderFns } from "./LexicalEditor.vue?vue&type=template&id=0b977dd2&"
import script from "./LexicalEditor.vue?vue&type=script&lang=js&"
export * from "./LexicalEditor.vue?vue&type=script&lang=js&"
import style0 from "./LexicalEditor.vue?vue&type=style&index=0&id=0b977dd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.8.1_vue-template-compiler@2.6.14_webpack@5.88.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports